module.exports = __webpack_public_path__ + "img/c.76ffb0f1.jpg";